// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';

// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Actions
import { UserActions, UserActionTypes } from '../_actions/user.actions';
// Models
import { User } from '../_models/user.model';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UsersState extends EntityState<User> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedUserId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  user_error: any;
  save_success: any;
}

export const adapter: EntityAdapter<User> = createEntityAdapter<User>();

export const initialUsersState: UsersState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastQuery: new QueryParamsModel({}),
  lastCreatedUserId: undefined,
  showInitWaitingMessage: true,
  user_error: null,
  save_success: null,
});

export function usersReducer(
  state = initialUsersState,
  action: UserActions
): UsersState {
  switch (action.type) {
    case UserActionTypes.UsersPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedUserId: undefined,
      };
    case UserActionTypes.UsersActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case UserActionTypes.UserOnServerCreated:
      return {
        ...state,
      };
    case UserActionTypes.UserErrored:
      return {
        ...state,
        user_error: action.payload,
      };
    case UserActionTypes.SaveSuccess:
      return {
        ...state,
        save_success: action.payload,
      };
    case UserActionTypes.UserCreated:
      return adapter.addOne(action.payload.user, {
        ...state,
        lastCreatedUserId: action.payload.user.id,
      });
    case UserActionTypes.UserLoaded:
      return adapter.upsertOne(action.payload.user, {
        ...state,
      });
    case UserActionTypes.UserUpdated:
      return adapter.updateOne(action.payload.partialUser, state);
    case UserActionTypes.UserDeleted:
      return adapter.removeOne(action.payload.id, state);
    case UserActionTypes.UsersPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };

    case UserActionTypes.AllUsersLoaded:
      return adapter.addMany(action.payload.users, state);

    case UserActionTypes.UsersPageLoaded: {
      return adapter.addMany(action.payload.users, {
        ...initialUsersState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    default:
      return state;
  }
}

export const getUserState = createFeatureSelector<UsersState>('users');

export const { selectAll, selectEntities, selectIds, selectTotal } =
  adapter.getSelectors();
